import { useQuery } from 'react-query';
import { ApiClient, Config } from 'src/clients';

export function useGetAuthConfig() {
  const fetchConfig = async (): Promise<Config> => {
    return await ApiClient.getConfiguration();
  };

  const { data, isLoading, isError, error } = useQuery<Config>('config', fetchConfig);

  return {
    oauth: {
      authority: data?.authority,
      clientId: data?.clientId,
      issuer: data?.issuer,
      audience: data?.audience,
      logoutUri: data?.logoutUri,
    },
    isLoading,
    isError,
    error,
  };
}
